import possibleTypesJson from './possibleTypes.json';

export const possibleTypes = possibleTypesJson;
